import {
  FETCH_TASK_CATEGORIES_SUCCESS,
  ADD_TASK_CATEGORY,
  UPDATE_TASK_CATEGORY,
  DELETE_TASK_CATEGORY,
  SET_SELECTED_TASK_CATEGORY,
} from "actions/taskCategories";
import { produce } from "immer";

const initialState = {
  TaskCategories: [],
  selectedTaskCategoryId: -1,
  error: "",
};

const taskCategoriesReducer = (state = initialState, action) =>
  produce(state, (draft) => {
    let key = 0;
    switch (action.type) {
      case FETCH_TASK_CATEGORIES_SUCCESS:
        draft.TaskCategories = action.payload;
        draft.error = "";
        break;
      case ADD_TASK_CATEGORY:
        draft.TaskCategories = [...draft.TaskCategories, action.payload];
        break;
      case UPDATE_TASK_CATEGORY:
        key = draft.TaskCategories.findIndex(
          (TC) => parseInt(TC.id) === parseInt(action.payload.id)
        );
        draft.TaskCategories[key] = action.payload;
        break;
      case DELETE_TASK_CATEGORY:
        key = draft.TaskCategories.findIndex(
          (TC) => parseInt(TC.id) === parseInt(action.payload.id)
        );
        draft = { TaskCategories: draft.TaskCategories.splice(key, 1) };
        break;
      case SET_SELECTED_TASK_CATEGORY:
        draft.selectedTaskCategoryId = action.payload
        break
      default:
        return state;
    }
  });

export default taskCategoriesReducer;
